import state from '~store/modules/dynamic/state'
import actions from '~store/modules/dynamic/actions'
import mutations from '~store/modules/dynamic/mutations'

export default {
  state,
  actions,
  mutations
}
